import React from "react"
import { EditableCell } from "./EditableCell"

export class ProductRow extends React.PureComponent {
    onDelEvent() {
      this.props.onDelEvent(this.props.product)
    }
    render() {
      const {onProductTableUpdate, cd, onProductTableDate} = this.props
      var key = 0;
      return (
        <tr className="eachRow">
          {cd.map(cellInfo => {
              return (<EditableCell key={key++} onProductTableUpdate={onProductTableUpdate} onProductTableDate={onProductTableDate} cellData={cellInfo} /> )
          })}
         
          <td className="del-cell">
                <input type="button" onClick={this.onDelEvent.bind(this)} value="X" className="del-btn"/>
            </td>
        </tr>
      )
  
    }
  
  }
  
  